/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  eqeqeq,
  import/no-extraneous-dependencies,
  no-void,
  react/no-string-refs
*/
import './index.scss';
import React from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import FixedModal from 'common/components/fixed-modal';
import Button from 'common/components/button';
import { ErrorMessage }
  from 'common/messages';
import errorCodes from 'signer/api/errors';
import Loader from 'signer/components/common/loader';
import logger from 'common/logger';
import CloseImageSrc from 'common/assets/modal-close@2x.png';
import { postMessage, messages } from 'common/utils/messages';


const hsMessages = defineMessages({
  declineFailed: {
    id: '',
    description: 'error message in modal of signer flow, shows when tyring to decline the signature request',
    defaultMessage: 'decline failed',
  },
});

class ConfirmDecline extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      errors: {},
    };

    this.decline = this.decline.bind(this);
    this.close = this.close.bind(this);
    this.checkLength = this.checkLength.bind(this);
    this.hasErrors = this.hasErrors.bind(this);
  }

  componentDidMount() {
    logger.track('ConfirmDecline.componentDidMount');
  }

  checkLength() {
    const reason = this.refs.declineReason.value;
    const errors = this.state.errors;
    if (!reason) {
      errors.noReason = true;
    } else {
      errors.noReason = false;
    }
    this.setState({ errors });
  }

  hasErrors() {
    const errorKeys = Object.keys(this.state.errors);
    const errors = errorKeys.filter((key) => this.state.errors[key] === true);
    return errors.length > 0;
  }

  decline() {
    this.checkLength();
    if (this.hasErrors()) {
      return;
    }

    const reason = this.refs.declineReason.value.trim();
    const { signatureRequest, router, notifier } = this.props.app;
    this.listeningAsyncResponse = true;
    logger.track('ConfirmDecline.decline');
    signatureRequest.decline(reason)
      .then((response) => {
        if (this.props.app.isEmbedded()) {
          HelloSign.XWM.send('decline', this.props.app.signatureRequest.embeddedData.parentUrl);

          // Embedded V2
          postMessage({
            type: messages.USER_DECLINE_REQUEST,
            payload: {
              signatureId: this.props.app.signatureRequest.embeddedData.signatureId,
              reason,
            },
          }, this.props.app.signatureRequest.embeddedData.parentUrl);
        }

        if (response.redirect_url != void 0) {
          window.location = response.redirect_url;
        } else {
          router.redirect('declineComplete');
        }
      })
      .catch(() => {
        this.listeningAsyncResponse = false;
        this.close();
        const error = new Error(this.props.intl.formatMessage(hsMessages.declineFailed));
        error.code = errorCodes.SERVER;
        notifier.notify(ErrorMessage.create(error, this));
      });
  }

  close() {
    this.props.app.router.hideFullScreenModal();
  }

  render() {
    const app = this.props.app;

    const closeButton = (<div className='close-button' onClick={this.close}><img src={CloseImageSrc} /></div>);

    let errors;
    if (this.state.errors.noReason) {
      errors = (
        <div className='error'>
          <FormattedMessage
            id="signer.decline.modal.noReasonError"
            description="error message in modal of signer flow, asking user to put reason behind declining the signature request"
            defaultMessage="Please provide a reason." />
        </div>
      );
    }

    const mainContent = (
      <div className='main-content'>
        <h1>
          <FormattedMessage
            id="signer.decline.modal.title"
            description="title text of modal in signer flow, when declining the signature request"
            defaultMessage="Decline to sign this document" />
        </h1>
        <p>
          <FormattedMessage
            id="signer.decline.modal.description"
            description="text in modal of signer flow, informing that decline of request will be informed to sender and all changes will be cleared"
            defaultMessage="Declining this document will clear anything you have entered and notify the sender." />
        </p>
        <div>
          <h2>
            <FormattedMessage
              id="signer.decline.modal.reasonTitle"
              description="label text in modal for signer flow, asking singer to put reason for decline"
              defaultMessage="Reason for declining" />
            <span className='asterisk'>*</span>
          </h2>
          <small>
            <FormattedMessage
              id="signer.decline.modal.sharedOnlyWithSender"
              description="text in modal of signer flow, informing that the decline reasin will only be sent to sender"
              defaultMessage="This information will be shared only with the sender." />
          </small>
          <textarea
            ref='declineReason'
            maxLength={255} />
          { errors }
        </div>
      </div>
    );

    const ctaBar = (
      <div className='cta-bar'>
        <Button
          buttonText={<FormattedMessage
            id="signer.decline.modal.declineButton"
            description="button text in modal of signer flow, when cliked declines the signature request"
            defaultMessage="Decline" />}
          onClick={this.decline}
          buttonColor='cerulean'
          buttonTextColor='white'
          buttonTextUppercase={true} />
        <div className='cancel-link' onClick={this.close}>
          <FormattedMessage
            id="signer.decline.modal.cancelButton"
            description="button text in modal of singer flow, when clicked closes the modal"
            defaultMessage="Cancel" />
        </div>
      </div>
    );

    const spinner = (
      <Loader className='loader' />
    );

    const modalStyle = app.isMobile ? { borderRadius: 0 } : { borderRadius: 5 };

    const fixedModalAttrs = {
      width: 600,
      modalStyle,
      hideOnOverlayClick: true,
    };

    return (
      <FixedModal {...this.props} {...fixedModalAttrs}>
        <div className='m-modal-confirm-decline'>
          { closeButton }
          { this.listeningAsyncResponse ? spinner : mainContent }
          { this.listeningAsyncResponse ? '' : ctaBar }
        </div>
      </FixedModal>
    );
  }
}

export default injectIntl(ConfirmDecline);
